import RgaRecalledPartAnalysis from '../../rga/recalled-part-analysis/state-connector';

export default {
    component: RgaRecalledPartAnalysis,
    name: 'Part Request Details',
    path: '/rga/recalled/returned-part'
};



// WEBPACK FOOTER //
// ./src/routes/rga/returned-part-analysis.js